import { Card } from '~ui/base/card';
import { Skeleton } from '~ui/base/skeleton';

interface SearchSkeletonProps {
  count?: number;
}

/** Loading state — placeholders that match the result-card shape. */
function SearchSkeleton({ count = 3 }: SearchSkeletonProps) {
  return (
    <ul className="flex flex-col gap-y-4" aria-busy aria-live="polite">
      {Array.from({ length: count }).map((_, idx) => (
        <li key={idx}>
          <Card ornament="outline" className="flex flex-col gap-y-4">
            <div className="flex flex-col gap-y-2">
              <Skeleton className="h-3 w-2/5" />
              <Skeleton className="h-6 w-4/5" />
            </div>
            <div className="flex flex-col gap-y-2">
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-11/12" />
              <Skeleton className="h-3 w-9/12" />
            </div>
            <div className="flex gap-x-2">
              <Skeleton className="h-5 w-16 rounded-full" />
              <Skeleton className="h-5 w-20 rounded-full" />
              <Skeleton className="h-5 w-14 rounded-full" />
            </div>
          </Card>
        </li>
      ))}
    </ul>
  );
}

export { SearchSkeleton };
